// --- Dependencies -------------------------------------------------------------------------------
import { Navigate, Outlet } from "react-router-dom";
// --- Our Modules --------------------------------------------------------------------------------
import useAuth from "@/hooks/useAuth";
import useOrganization from "@/hooks/useOrganization";
import AppBar from "@/UI/components/AppBar";
import BottomBar from "@/UI/components/BottomBar";
import SideBar from "@/UI/components/SideBar";
import UploadTray from "@/UI/components/UploadTray";
import "./styles.css";
// --- Logic --------------------------------------------------------------------------------------
/**
 * The gate: no token means sign in, no chosen organization means pick one.
 *
 * The sidebar is the first child of a plain row, so it lands on the inline-start edge — the right in
 * Arabic, the left in English — without the layout knowing which language is on.
 *
 * The upload tray lives here for the same reason it is not a popup: uploads must survive navigating
 * away from the screen that started them.
 */
export default function DashboardLayout() {
    const token = useAuth((state) => state.token);
    const organizationId = useOrganization((state) => state.organizationId);

    if (!token) return <Navigate to="/login" replace />;
    if (!organizationId) return <Navigate to="/select-organization" replace />;

    return (
        <div className="dashboard-layout">
            <SideBar />
            <div className="dashboard-layout__content">
                <AppBar />
                <main className="dashboard-layout__main">
                    <Outlet />
                </main>
            </div>
            <BottomBar />
            {/* Mounted here, not by a screen: an upload has to outlive the page that started it. */}
            <UploadTray />
        </div>
    );
}
